import { render, staticRenderFns } from "./LectureSheet.vue?vue&type=template&id=6ca3f57a&"
import script from "./LectureSheet.vue?vue&type=script&lang=js&"
export * from "./LectureSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports